import React from 'react';
import { Link } from 'react-router-dom';

export default function NavItem(props: { text: string; to: string }) {
    return (
        <Link to={props.to} className={'hover-effect text-base'}>
            {props.text}
        </Link>
    );
}
